"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REMOVE_FLASH_MESSAGE = exports.SHOW_FLASH_MESSAGE = exports.TOGGLE_NAVIGATION = void 0;
exports.TOGGLE_NAVIGATION = 'TOGGLE_NAVIGATION';
exports.SHOW_FLASH_MESSAGE = 'SHOW_FLASH_MESSAGE';
exports.REMOVE_FLASH_MESSAGE = 'REMOVE_FLASH_MESSAGE';
